exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time_picker_button {\n  padding: 5px 10px;\n  background-color: transparent;\n  display: inline-block;\n  color: #949494;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n  box-shadow: none;\n}\n\n.time_picker_button:hover {\n  opacity: 1;\n}\n", ""]);

// exports
